import React from "react";

export default class Loader extends React.Component {
    render() {
        return (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        );
    }
}
